import { useEffect, useRef, useState } from "react";
import { DetailsDataProvider } from "./View/Details";
import { useDetailPanelData } from "../useDetailPanelData";
import { EditDataProvider } from "./Edit/Edit";

interface OverlayMixinElement extends HTMLElement {
  toggleContainer(open: boolean): void;
}

interface SidePanelToggleEvent extends Event {
  newState?: "open" | "closed";
}

export function DetailPanel() {
  const sidepanelRef = useRef<OverlayMixinElement>(null);
  const { actionId, shuntingUnit, clearDetailPanelData } = useDetailPanelData();
  const [currentView, setCurrentView] = useState<"DETAILS" | "EDIT">("DETAILS");

  useEffect(() => {
    sidepanelRef.current?.toggleContainer(actionId !== undefined);
    setCurrentView("DETAILS");
  }, [actionId, shuntingUnit, sidepanelRef, setCurrentView]);

  return (
    <tractie-side-panel
      ref={sidepanelRef}
      dismissible
      hidden // Hide by default
      ontoggle={(e: SidePanelToggleEvent) => {
        if (e.newState === "closed") {
          clearDetailPanelData();
        }
      }}
    >
      {currentView === "DETAILS" && actionId && shuntingUnit && (
        <DetailsDataProvider
          actionId={actionId}
          shuntingUnit={shuntingUnit}
          onEdit={() => setCurrentView("EDIT")}
        />
      )}
      {currentView === "EDIT" && actionId && (
        <EditDataProvider onClose={() => setCurrentView("DETAILS")} actionId={actionId} />
      )}
    </tractie-side-panel>
  );
}
